import React from 'react';
import { Box, Typography } from '@mui/material';

function PropertyDetailPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Property Details</Typography>
      <Typography variant="body1">Individual property analysis page coming soon...</Typography>
    </Box>
  );
}

export default PropertyDetailPage;
